import * as Website from '../../../Config/Website.js';
import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { gsap } from 'gsap';

const instance = {
  slider: null,
  marquee: null,
  background: null,
}

const init = () => {
  const targetElm = document.getElementById('js-mv');
  if(!targetElm) return;
//   const marqueeElm = targetElm.querySelector('.js-marquee');
  const sliderElm = targetElm.querySelector('.js-slider');
  const backgroundElm = targetElm.querySelector('.js-background');

//   instance.marquee = new Splide(marqueeElm, {
//     type: "loop",
//     arrows: false,
//     pagination: false,
//     autoWidth: true,
//     autoplay: false,
//     focus: "center",
//     drag: false,
//     gap: "0",
//     autoScroll: {
//       autoplay: true,
//       speed: 1,
//       pauseOnHover: false,
//       pauseOnFocus: false,
//     }
//   });

  instance.slider = new Splide(sliderElm, {
    type: "fade",
    arrows: false,
    pagination: false,
    perPage: 1,
    perMove: 1,
    rewind: true,
    rewindSpeed: 400,
    speed: 400,
    interval: 4000,
    // autoplay: 'pause',
    pauseOnHover: false,
    pauseOnFocus: false,
  });
  
  instance.background = new Splide(backgroundElm, {
    type: "loop",
    arrows: false,
    pagination: false,
    autoWidth: true,
    // autoplay: false,
    focus: "center",
    drag: false,
    gap: "-3%",
    autoScroll: {
      autoplay: true,
      speed: 1.5,
      pauseOnHover: false,
      pauseOnFocus: false,
    }
  });

  
  instance.slider.on('mounted', () => {
    const firstSlide = instance.slider.Components.Slides.getAt(0);
    const allSlides = instance.slider.Components.Slides.get();
    allSlides.filter(slide => slide !== firstSlide).forEach(slide => {
      gsap.set(slide.slide.querySelector('.js-eyecatch'), {
        scale: 0.85,
      });
    });
  });
  instance.slider.on('moved', (next, prev) => {
    const nextSlide = instance.slider.Components.Slides.getAt(next).slide;
    const prevSlide = instance.slider.Components.Slides.getAt(prev).slide;
    gsap.set(prevSlide.querySelector('.js-eyecatch'), {
      scale: 0.85,
    });
    gsap.to(nextSlide.querySelector('.js-eyecatch'), {
      scale: 1,
      duration: 0.5,
      ease: 'back.out',
    });
  });


  instance.slider.mount();
  // instance.marquee.mount({AutoScroll});
  instance.background.mount({AutoScroll});
  
}

const load = () => {
  const targetElm = document.getElementById('js-mv');
  if(!targetElm) return;
  targetElm.classList.add(Website.classList.act);
  instance.slider.Components.Autoplay.play();
}

export {
  init,
  load
}